import React, { useState, useEffect } from 'react';
import clientPortalService from '../../services/clientPortalService';

// One admin-settable line, shown across every portal screen. Silence generates
// contacts — a client who hits a known issue and sees nothing calls the lawyer.
export default function PortalBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => clientPortalService.getBanner()
      .then((b) => { if (alive) setBanner(b && b.active ? b : null); })
      .catch(() => {});
    load();
    const t = setInterval(load, 120000); // refresh so a mid-session flip shows
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!banner || !banner.active || !banner.message) return null;
  const warn = banner.level === 'warning';
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2147482000,
      background: warn ? '#7c2d12' : '#0f2740',
      color: warn ? '#ffedd5' : '#dbeafe',
      borderBottom: `1px solid ${warn ? '#c2410c' : '#2b6cb0'}`,
      padding: 'calc(6px + env(safe-area-inset-top)) 14px 6px',
      font: '600 13px system-ui', textAlign: 'center',
    }}>
      {banner.message}
    </div>
  );
}
